import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';

import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';

import { runWithAdal } from 'react-adal';
import { authContext } from './adalConfig';

const store = configureStore();

runWithAdal(authContext, () => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <App />
    </Provider>,
  );
});
